import type { Category } from '../types/products';

export const categories: Category[] = [
  {
    slug: 'petroleum-sulphonates',
    name: 'Petroleum Sulphonates',
    tagline: 'Sodium & calcium sulphonates for emulsification and corrosion control',
    intro:
      'Our DAXOL range of sodium and calcium petroleum sulphonates is made from petroleum oil feedstocks with a broad average equivalent weight distribution — delivering excellent emulsification, superior rust prevention and reliable performance across formulations.',
    icon: 'droplet',
    applications: ['Metalworking', 'Oilfield', 'Mining', 'Industrial Oils'],
  },
  {
    slug: 'metalworking-fluids',
    name: 'Metalworking Fluids',
    tagline: 'Emulsifiers, semi-synthetics, neat cutting oils & rust preventives',
    intro:
      'A complete additive toolkit for the metalworking industry — from soluble cutting oil emulsifier packages and semi-synthetic concentrates to neat cutting oils and rust-preventive additives engineered for long service life and dependable corrosion protection.',
    icon: 'gear',
    applications: ['Cutting & Grinding', 'Corrosion Protection', 'Forming', 'Fluid Concentrates'],
  },
  {
    slug: 'textile-additives',
    name: 'Textile Additives',
    tagline: 'Knitting & coning oil emulsifier packages',
    intro:
      'Emulsifier packages formulated for spinning, knitting and coning oils — engineered for excellent scour, static protection and reduced needle wear in high-speed textile processing.',
    icon: 'thread',
    applications: ['Knitting Oils', 'Coning Oils', 'Spin Finishes', 'Level Dyeing'],
  },
  {
    slug: 'fuel-petroleum-dyes',
    name: 'Fuel & Petroleum Dyes',
    tagline: 'Solvent-soluble dyes for fuels, oils & lubricants',
    intro:
      'A vibrant range of solvent-soluble dyes formulated for non-aqueous solvents, oils and petroleum-based products — ensuring stable, brilliant coloration for identification, branding and tax-compliance across industrial and automotive applications.',
    icon: 'palette',
    applications: ['Fuel Marking', 'Lubricant Branding', 'Tax Compliance', 'Product Identification'],
  },
];

export const getCategory = (slug: string): Category | undefined =>
  categories.find((c) => c.slug === slug);
